import { memo } from 'react';
import PropTypes from 'prop-types';

import CFLink from '../CFLink';

import Styles from './styles.module.scss';

const planToContentMapping = new Map([
  ['silver_plan', { text: 'SILVER', className: Styles.silver }],
  ['gold_plan', { text: 'GOLD', className: Styles.gold }],
  ['platinum_plan', { text: 'PLATINUM', className: Styles.platinum }],
]);

export const PremiumBadge = ({ plan, href, className = '' }) => {
  const { text, className: planClassName = '' } = planToContentMapping.get(plan) ?? {};

  const classNames = `${Styles['premium-badge']} ${planClassName} ${className}`;
  return href ? (
    <CFLink
      to={href}
      className={classNames}
      external={href?.startsWith('http')}
    >
      {text}
    </CFLink>
  ) : (
    <span className={classNames}>
      {text}
    </span>
  );
};

PremiumBadge.propTypes = {
  plan: PropTypes.oneOf([
    'silver_plan',
    'gold_plan',
    'platinum_plan',
  ]).isRequired,
};

export default memo(PremiumBadge);
